<template>
    <div class="main">
        <div class="tabs is-centered is-boxed is-fullwidth">
            <ul>
                <li @click="toggleTab('1')" :class="[selectedTab == '1' ? 'is-active' : '']">
                    <a>
                        <span>Profile</span>
                    </a>
                </li>
                <li @click="toggleTab('2')" :class="[selectedTab == '2' ? 'is-active' : '']">
                    <a>
                        <span>Past FD</span>
                    </a>
                </li>
                <li @click="toggleTab('3')" :class="[selectedTab == '3' ? 'is-active' : '']">
                    <a>
                        <span>History</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div v-if="selectedTab == '1'">
        <BeneficiaryProfile :id="id"></BeneficiaryProfile>
    </div>
    <div v-else-if="selectedTab == '2'">
        <DeliveryHistory :beneficiaryID="id"></DeliveryHistory>
    </div>
    <div v-if="selectedTab == '3'">
        <BeneficiaryHistory :id="id"></BeneficiaryHistory>
    </div>
</template>

<script>
import BeneficiaryProfile from '@/components/beneficiary/BeneficiaryProfile.vue';
import BeneficiaryHistory from '@/components/beneficiary/BeneficiaryHistory.vue';
import DeliveryHistory from '@/components/beneficiary/DeliveryHistory.vue';

export default {
    components: {
        BeneficiaryProfile,
        DeliveryHistory,
        BeneficiaryHistory
    },
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            selectedTab: '1'
        }
    },
    methods: {
        toggleTab(to) {
            if (to != this.selectedTab) {
                this.selectedTab = to;
            }
        }
    },
    unmounted() {
        this.$store.dispatch('delivery/resetHistoricalDeliveries');
    }
}
</script>